import Select from "../../../components/common/Select";

import {
  PAYMENT_STATUS_OPTIONS
} from "../constants/payment.constants";

const PaymentFilters = ({
  filters,
  onFilterChange,
  onReset
}) => {
  return (
    <div className="payment-filters">
      <Select
        label="Status"
        value={
          filters.status
        }
        options={
          PAYMENT_STATUS_OPTIONS
        }
        onChange={(event) =>
          onFilterChange({
            status:
              event.target.value
          })
        }
      />

      <div className="payment-filters__actions">
        <button
          type="button"
          className="payment-filters__reset"
          onClick={onReset}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default PaymentFilters;
